import { styled } from "../../styles/index.js";
import { rootShouldForwardProp } from "@mui/material/styles/styled";
const TypographyRoot = styled("span", {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "TrueTypography",
  slot: "Root"
})(({ theme, ownerState }) => {
  const { "4": backgroundHighlight } = theme.palette.brandSupport || {
    "4": theme.palette.primary.main
  };
  let mobileStyle = {};
  const variant = ownerState.variant;
  if (theme.typography.mobile && ownerState.variant && theme.typography.mobile[variant]) {
    mobileStyle = {
      fontFamily: ownerState.fontFamily || theme.typography.mobile[variant].fontFamily,
      fontWeight: ownerState.fontFamily || theme.typography.mobile[variant].fontWeight,
      fontSize: ownerState.fontSize || theme.typography.mobile[variant].fontSize,
      lineHeight: ownerState.lineHeight || theme.typography.mobile[variant].lineHeight,
      letterSpacing: ownerState.letterSpacing || theme.typography.mobile[variant].letterSpacing,
      textTransform: ownerState.textTransform || theme.typography.mobile[variant].textTransform
    };
  }
  return {
    ...variant && theme.typography[variant],
    ...ownerState.noGutter && {
      margin: 0
    },
    ...ownerState.gutterBottom && {
      marginBottom: 0
    },
    ...ownerState.noWrap && {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    ...ownerState.strikethrough && {
      textDecoration: "line-through"
    },
    ...ownerState.highlight && {
      "& strong": {
        background: backgroundHighlight,
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent",
        backgroundClip: "text",
        textFillColor: "transparent",
        fontWeight: "inherit"
      }
    },
    [theme.breakpoints.down("md")]: {
      ...mobileStyle
    }
  };
});
export {
  TypographyRoot
};
//# sourceMappingURL=typography.styles.js.map
